<template>
  <div class="py-4 container-fluid">
    <div class="row mb-4">
      <div class="col-lg-12 position-relative z-index-2">
        <div class="row">
          <select
            v-model="filters.date"
            @change="fetchStatistics2()"
            class="form-select me-2 searchInput"
            style="width: fit-content; padding-left: 5px; padding-right: 15px;"
          >
            <option
              v-for="date in attenddate"
              :key="date.no"
              :value="date.dday"
            >
              {{ date.dday }}
            </option>
          </select>
          </div>

          <div style="margin-top:30px"></div>
<!-- 통계 -->       
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData5.attendanceCount}/${classData5.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData5.percent}%</span>`"
              :icon="{
                name: '영아1,2',
                color: 'text-white',
                background: 'primary',
              }"              
            />           
          </div>        
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData7.attendanceCount}/${classData7.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData7.percent}%</span>`"
              :icon="{
                name: '유아부',
                color: 'text-white',
                background: 'primary',
              }"              
            />   
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData8.attendanceCount}/${classData8.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData8.percent}%</span>`"
              :icon="{
                name: '새싹부',
                color: 'text-white',
                background: 'primary',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData9.attendanceCount}/${classData9.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData9.percent}%</span>`"
              :icon="{
                name: '유치부',
                color: 'text-white',
                background: 'primary',
              }"              
            />  
          </div>          
        </div>
<div style="margin-top:30px"></div>

        <div class="row">
<!--  취학부 -->          
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData12.attendanceCount}/${classData12.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData12.percent}%</span>`"
              :icon="{
                name: '유년부',
                color: 'text-white',
                background: 'success',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData10.attendanceCount}/${classData10.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData10.percent}%</span>`"
              :icon="{
                name: '열매1',
                color: 'text-white',
                background: 'success',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData11.attendanceCount}/${classData11.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData11.percent}%</span>`"
              :icon="{
                name: '열매2',
                color: 'text-white',
                background: 'success',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData13.attendanceCount}/${classData13.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData13.percent}%</span>`"
              :icon="{
                name: '초등부',
                color: 'text-white',
                background: 'success',
              }"              
            />  
          </div>

        </div>

        <div style="margin-top:30px"></div>

        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData14.attendanceCount}/${classData14.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData14.percent}%</span>`"
              :icon="{
                name: '소년부',
                color: 'text-white',
                background: 'success',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData1.attendanceCount}/${classData1.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData1.percent}%</span>`"
              :icon="{
                name: '청1',
                color: 'text-white',
                background: 'info',
              }"              
            />  
          </div>          
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData4.attendanceCount}/${classData4.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData4.percent}%</span>`"
              :icon="{
                name: '청1+',
                color: 'text-white',
                background: 'info',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData2.attendanceCount}/${classData2.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData2.percent}%</span>`"
              :icon="{
                name: '청2',
                color: 'text-white',
                background: 'info',
              }"              
            /> 
          </div>          
        </div>

        <div style="margin-top:30px"></div>
        
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData3.attendanceCount}/${classData3.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData3.percent}%</span>`"
              :icon="{
                name: '청3',
                color: 'text-white',
                background: 'info',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData15.attendanceCount}/${classData15.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData15.percent}%</span>`"
              :icon="{
                name: '키즈',
                color: 'text-white',
                background: 'warning',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData16.attendanceCount}/${classData16.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData16.percent}%</span>`"
              :icon="{
                name: '소망1',
                color: 'text-white',
                background: 'warning',
              }"              
            />  
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <mini-statistics-card
              :title="{ 
                text: '', 
                value: `${classData17.attendanceCount}/${classData17.totalStudents}` 
              }"
              :detail="`<span class='text-success text-sm font-weight-bolder'>${classData17.percent}%</span>`"
              :icon="{
                name: '소망2',
                color: 'text-white',
                background: 'warning',
              }"              
            /> 
          </div>Boazsystem          
        </div>

        <div style="margin-top:30px"></div>

        <div class="row">

          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
          
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
          
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6 mt-lg-0 mt-4">
          
          </div>
        </div>

<!-- end -->                
<!--
        <div class="row mt-4">
          <div class="col-lg-4 col-md-6 mt-4">
            <chart-holder-card
              title="Website Views"
              subtitle="Last Campaign Performance"
              update="campaign sent 2 days ago"
            >
              <reports-bar-chart
                :chart="{
                  labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
                  datasets: {
                    label: 'Sales',
                    data: [50, 20, 10, 22, 50, 10, 40],
                  },
                }"
              />
            </chart-holder-card>
          </div>
          <div class="col-lg-4 col-md-6 mt-4">
            <chart-holder-card
              title="Daily Sales"
              subtitle="(<span class='font-weight-bolder'>+15%</span>) increase in today sales."
              update="updated 4 min ago"
              color="success"
            >
              <reports-line-chart
                :chart="{
                  labels: [
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec',
                  ],
                  datasets: {
                    label: 'Mobile apps',
                    data: [50, 40, 300, 320, 500, 350, 200, 230, 500],
                  },
                }"
              />
            </chart-holder-card>
          </div>
          <div class="col-lg-4 mt-4">
            <chart-holder-card
              title="Completed Tasks"
              subtitle="Last Campaign Performance"
              update="just updated"
              color="dark"
            >
              <reports-line-chart
                id="tasks-chart"
                :chart="{
                  labels: [
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec',
                  ],
                  datasets: {
                    label: 'Mobile apps',
                    data: [50, 40, 300, 220, 500, 250, 400, 230, 500],
                  },
                }"
              />
            </chart-holder-card>
          </div>
        </div>
      -->
      </div>
    </div>
<!--
    <div class="row">
      <div class="col-lg-8 col-md-6 mb-md-0 mb-4">
        <project-card
          title="Projects"
          description="<i class='fa fa-check text-info' aria-hidden='true'></i> <span class='font-weight-bold ms-1'>30 done</span> this month"
          :headers="['Companies', 'Members', 'Budget', 'Progress']"
          :projects="[
            {
              logo: logoXD,
              title: 'Material XD Material XD Version',
              members: [team1, team2, team3, team4],
              budget: '$14,000',
              progress: { percentage: 60, color: 'info' },
            },
            {
              logo: logoAtlassian,
              title: 'Add Progress Track',
              members: [team2, team4],
              budget: '$3,000',
              progress: { percentage: 10, color: 'info' },
            },
            {
              logo: logoSlack,
              title: 'Fix Platform Errors',
              members: [team3, team1],
              budget: 'Not set',
              progress: { percentage: 100, color: 'success' },
            },
            {
              logo: logoSpotify,
              title: 'Launch our Mobile App',
              members: [team4, team3, team4, team1],
              budget: '$20,500',
              progress: { percentage: 100, color: 'success' },
            },
            {
              logo: logoJira,
              title: 'Add the New Pricing Page',
              members: [team4],
              budget: '$500',
              progress: { percentage: 25, color: 'info' },
            },
            {
              logo: logoJira,
              title: 'Redesign New Online Shop',
              members: [team1, team4],
              budget: '$2,000',
              progress: { percentage: 40, color: 'info' },
            },
          ]"
        />
      </div>
      <div class="col-lg-4 col-md-6">
        <timeline-list
          class="h-100"
          title="Orders overview"
          description="<i class='fa fa-arrow-up text-success' aria-hidden='true'></i>
        <span class='font-weight-bold'>24%</span> this month"
        >
          <timeline-item
            :icon="{
              component: 'notifications',
              class: 'text-success',
            }"
            title="$2400 Design changes"
            date-time="22 DEC 7:20 PM"
          />
          <TimelineItem
            :icon="{
              component: 'code',
              class: 'text-danger',
            }"
            title="New order #1832412"
            date-time="21 DEC 11 PM"
          />
          <TimelineItem
            :icon="{
              component: 'shopping_cart',
              class: 'text-info',
            }"
            title="Server payments for April"
            date-time="21 DEC 9:34 PM"
          />
          <TimelineItem
            :icon="{
              component: 'credit_card',
              class: 'text-warning',
            }"
            title="New card added for order #4395133"
            date-time="20 DEC 2:20 AM"
          />
          <TimelineItem
            :icon="{
              component: 'vpn_key',
              class: 'text-primary',
            }"
            title="Unlock packages for development"
            date-time="18 DEC 4:54 AM"
            class="pb-1"
          />
        </timeline-list>
      </div>
    </div>
    -->
  </div>
</template>
<script>
//import ChartHolderCard from "./components/ChartHolderCard.vue";
//import ReportsBarChart from "@/common/Charts/ReportsBarChart.vue";
//import ReportsLineChart from "@/common/Charts/ReportsLineChart.vue";
import MiniStatisticsCard from "./components/MiniStatisticsCard.vue";
//import ProjectCard from "./components/ProjectCard.vue";
//import TimelineList from "@/common/Cards/TimelineList.vue";
//import TimelineItem from "@/common/Cards/TimelineItem.vue";
import logoXD from "@/assets/img/small-logos/logo-xd.svg";
import logoAtlassian from "@/assets/img/small-logos/logo-atlassian.svg";
import logoSlack from "@/assets/img/small-logos/logo-slack.svg";
import logoSpotify from "@/assets/img/small-logos/logo-spotify.svg";
import logoJira from "@/assets/img/small-logos/logo-jira.svg";
import logoInvision from "@/assets/img/small-logos/logo-invision.svg";
import team1 from "@/assets/img/team-1.jpg";
import team2 from "@/assets/img/team-2.jpg";
import team3 from "@/assets/img/team-3.jpg";
import team4 from "@/assets/img/team-4.jpg";


import apiservice from "../services/apiservice";

export default {
  name: "dashboard-default",
  data() {
    return {
      logoXD,
      team1,
      team2,
      team3,
      team4,
      logoAtlassian,
      logoSlack,
      logoSpotify,
      logoJira,
      logoInvision,
      statistics: null,
      classData1: { attendanceCount: 0, totalStudents: 0, percent: 0 }, // 기본값
      classData2: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData3: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData4: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData5: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData6: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData7: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData8: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData9: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData10: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData11: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData12: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData13: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData14: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData15: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData16: { attendanceCount: 0, totalStudents: 0, percent: 0 },
      classData17: { attendanceCount: 0, totalStudents: 0, percent: 0 },      
      attenddate: [],
      filters: {
        date: "", // 초기값 설정
    },      
    };
  },
  async created() {
    await this.fetchSundays();
    await this.fetchStatistics2();
},

methods: {
  async fetchStatistics2() {

    console.log(this.filters.date);
    const data = {
      attenddate: this.filters.date
    };

    try {
    const response = await apiservice.fetchAttendanceStatistics(data);

    if (response && response.data) {
      this.statistics = response.data.data;

      // 각 데이터를 data 속성에 저장
      this.classData1 = this.getClassData("1");
      this.classData2 = this.getClassData("2");
      this.classData3 = this.getClassData("3");
      this.classData4 = this.getClassData("4"); // 청소년 1부+
      this.classData5 = this.getClassData("5");
      this.classData6 = this.getClassData("6");
      this.classData7 = this.getClassData("7");
      this.classData8 = this.getClassData("8");
      this.classData9 = this.getClassData("9");
      this.classData10 = this.getClassData("10");
      this.classData11 = this.getClassData("11");
      this.classData12 = this.getClassData("12");
      this.classData13 = this.getClassData("13");
      this.classData14 = this.getClassData("14");
      this.classData15 = this.getClassData("15");
      this.classData16 = this.getClassData("16");
      this.classData17 = this.getClassData("17");      

    } else {
      console.error("Unexpected response format:", response);
    }
  } catch (error) {
    console.error("Failed to fetch statistics:", error);
  }
  },
  getClassData(classid) {
    return (
      this.statistics
        .filter(stat => stat.classid === classid)
        .map(stat => ({
          attendanceCount: stat.attendance_count || 0,
          totalStudents: stat.total_students || 0,
          percent: stat.percent || 0,
        }))[0] || { attendanceCount: 0, totalStudents: 0, percent: 0 }
    );
  },
  async fetchSundays() {
      try {
        const response = await apiservice.getsunday();
        this.attenddate = response.data.data.map(date => ({
          no: date.no,
          dday: date.dday,
        }));
        
        // 첫 번째 항목을 기본값으로 설정
        if (this.attenddate.length > 0) {
          this.filters.date = this.attenddate[0].dday;
        }
      } catch (error) {
        console.error("Failed to fetch Sundays:", error);
      }
    },  
    },
mounted() {
    
  },
  components: {
    //ChartHolderCard,
    //ReportsBarChart,
    //ReportsLineChart,
    MiniStatisticsCard,
    //ProjectCard,
    //TimelineList,
    //TimelineItem,
  },
};
</script>
